<div *ngIf="reportType == 'JahitatJamaPratinidiReport'" class="report-wrapper">
    <div class="report-container" id="print-section">


        <!-- Report Title -->
        <div class="report-title-row" style="text-align: center; color: black;">
            <h1> {{ officeName }} &nbsp;-&nbsp; जाहिरात जमा &nbsp;-&nbsp; ( {{ reportYearRange }} )</h1>
        </div>

        <!-- Table -->
        <div class="table-container">
            <table class="report-table">
                <thead>
                    <!-- ROW 1: Column headers + Month group headers -->
                    <tr>
                        <th rowspan="2" class="col-sr">अ.<br>क्र.</th>
                        <th rowspan="2" class="col-name">प्रतिनिधी</th>
                        <th rowspan="2" class="col-place">ठिकाण</th>
                        <th *ngFor="let m of selectedMonths" colspan="2" class="month-header"
                            style="text-align: center;">
                            {{ m.name }}
                        </th>
                        <th colspan="2" class="month-header ekun-header">
                            एकूण जमा<br>
                        </th>
                    </tr>
                    <!-- ROW 2: Sub-headers -->
                    <tr>
                        <ng-container *ngFor="let m of selectedMonths">
                            <th class="sub-header">जाहिरात</th>
                            <th class="sub-header">देणगी</th>
                        </ng-container>
                        <th class="sub-header ekun-sub">जाहिरात</th>
                        <th class="sub-header ekun-sub">देणगी</th>
                    </tr>
                </thead>

                <tbody *ngFor="let office of advtFormBeans; let i = index">

                    <!-- Office Representative Header -->
                    <tr class="office-header-row" style="background-color: aqua;">
                        <td [attr.colspan]="3 + (selectedMonths.length * 2) + 2">
                            कार्यालय प्रतिनिधी: {{ office.office_rep }}
                        </td>
                    </tr>

                    <!-- Representative Data Rows (ONE ROW PER REP) -->
                    <tr *ngFor="let rep of office.rep_data; let j = index" class="rep-row">
                        <td class="col-sr">{{ i + 1 }}</td>
                        <td class="col-name" style="white-space: nowrap;text-align: left;">{{ rep.rep_name }}</td>
                        <td class="col-place" style="white-space: nowrap;text-align: left;">{{ rep.district || '' }}
                        </td>

                        <ng-container *ngFor="let m of selectedMonths">
                            <td class="amount-cell" style="text-align: end;">{{ rep[m.index] || '' }}</td>
                            <td class="amount-cell" style="text-align: end;">{{ rep['dngee_' + m.index] || '' }}</td>
                        </ng-container>

                        <!-- Ekun Jama totals -->
                        <td class="amount-cell ekun-cell" style="text-align: end;">{{ rep.rcv_amt || '' }}</td>
                        <td class="amount-cell ekun-cell" style="text-align: end;">{{ rep.rcv_dngee || '' }}</td>
                    </tr>

                    <!-- Office Subtotal Row -->
                    <!-- Office Subtotal Row (already in your HTML - no changes needed) -->
                    <tr class="subtotal-row">
                        <td colspan="3" class="subtotal-label">एकूण जमा</td>
                        <ng-container *ngFor="let m of selectedMonths">
                            <td class="amount-cell" style="text-align: end;">{{ office['total_' + m.index] || '' }}</td>
                            <td class="amount-cell" style="text-align: end;">{{ office['total_dngee_' + m.index] || ''
                                }}</td>
                        </ng-container>
                        <td class="amount-cell ekun-cell" style="text-align: end;">{{ office.total || '' }}</td>
                        <td class="amount-cell ekun-cell" style="text-align: end;">{{ office.total_dngee || '' }}</td>
                    </tr>

                    <!-- Grand Total (combined) Row -->
                    <!-- <tr class="grand-total-row">
                        <td colspan="3" class="subtotal-label">एकूण</td>
                        <ng-container *ngFor="let m of selectedMonths">
                            <td colspan="2" class="amount-cell">{{ office['ekun_' + m.index] || '' }}</td>
                        </ng-container>
                        <td colspan="2" class="amount-cell ekun-cell">{{ office.ekun_total || '' }}</td>
                    </tr> -->

                </tbody>
                <tfoot>
                    <tr class="subtotal-row" style="font-weight: bold; background-color: #ffe082;">
                        <td colspan="3" style="text-align: center; font-weight: bold;">एकूण</td>

                        <ng-container *ngFor="let m of selectedMonths">
                            <td class="amount-cell" style="text-align: end; font-weight: bold;">
                                {{ monthlyTotals[m.index] || '' }}
                            </td>
                            <td class="amount-cell" style="text-align: end; font-weight: bold;">
                                {{ monthlyDngeeTotals[m.index] || '' }}
                            </td>
                        </ng-container>

                        <td class="amount-cell ekun-cell" style="text-align: end; font-weight: bold;">
                            {{ grandTotal || '' }}
                        </td>
                        <td class="amount-cell ekun-cell" style="text-align: end; font-weight: bold;">
                            {{ grandTotalDngee || '' }}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>

    </div>

    <!-- Action Buttons -->
    <div class="action-buttons noPrint">
        <button class="btn btn-print" (click)="printPageA3Landscape()">🖨️ Print</button>
        <button class="btn btn-export" (click)="exportExcel()">📥 Export</button>
        <button class="btn btn-close noPrint" mat-button mat-dialog-close>
            <mat-icon>close</mat-icon>
            Close
        </button>
    </div>
</div>